"use client";

import styles from "./CeoSection.module.css";
import { Header2, P1 } from "@bumble/ui-kit";
import MaxWidth from "@/components/MaxWidth";
import { useMediaQuery } from "@/lib/hooks/useMediaQuery";
import { stripOuterPTag } from "@/lib/utils/stripOuterPTag";
const PLACEHOLDER_IMAGE = "/assets/placeholder-background.png";
export interface CeoSectionData {
  badgeText?: string;
  title?: string;
  copy?: string;
  imageDesktop?: {
    url?: string;
    alt?: string;
  };
  imageTablet?: {
    url?: string;
    alt?: string;
  };
  imageMobile?: {
    url?: string;
    alt?: string;
  };
}
interface Props {
  data?: CeoSectionData;
}
export default function CeoSection({
  data
}: Props) {
  const isMobile = useMediaQuery(768);
  const isTablet = useMediaQuery(1024);
  const desktop = data?.imageDesktop;
  const tablet = data?.imageTablet;
  const mobile = data?.imageMobile;
  const imageSrc = isMobile ? mobile?.url || desktop?.url : isTablet ? tablet?.url || desktop?.url : desktop?.url;
  const imageAlt = isMobile ? mobile?.alt || desktop?.alt : isTablet ? tablet?.alt || desktop?.alt : desktop?.alt;
  const title = data?.title?.trim() ?? "";
  const copy = data?.copy?.trim() ?? "";
  if (!title && !copy && !imageSrc) {
    return null;
  }
  return <MaxWidth>
      <div className={styles.ceo__section}>
        <div className={styles.left}>
          <div className={styles.badge}>
            {data?.badgeText?.trim() || "Our Founder"}
          </div>

          {title ? <Header2>{title}</Header2> : null}
          {copy ? <P1 html={copy ? stripOuterPTag(copy) : ""} /> : null}
        </div>

        <div className={styles.right}>
          <div className={styles.image__wrap}>
            <div className={styles.sizer}></div>
            <div className={styles.bsz}>
              <img src={imageSrc || PLACEHOLDER_IMAGE} alt={imageAlt?.trim() || title || "CEO"} loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </MaxWidth>;
}